import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { keyBy, uniqBy } from 'lodash';

import './index.scss';
import CommonTable from '../../common/table';
import {
  REDUCER_NAME,
  fetchPremiumAnalysis,
  resetStoreData,
} from '../../reducer';
import Const from '../../Const';
import { getDataFollowKeyByDot } from '../../../helpers/Common';

class PremiumAnalysis extends React.Component {
  componentDidMount() {
    const { fetchPremiumAnalysis, resetStoreData } = this.props;
    resetStoreData('premiumAnalysisData');
    fetchPremiumAnalysis();
  }

  componentDidUpdate(prevProps) {
    const { fetchPremiumAnalysis, resetStoreData } = this.props;
    if (prevProps.i18n.locale !== this.props.i18n.locale) {
      resetStoreData('premiumAnalysisData');
      fetchPremiumAnalysis();
    }
  }

  render() {
    const {
      premiumAnalysisData: { data, isLoading, isShortByFavorite, storeName },
      premiumAnalysisData,
    } = this.props;

    const filteredData = data;
    //data with condition
    const listIdsInLocalStore =
      JSON.parse(localStorage.getItem(storeName)) || [];
    //data in Local Store
    const uniqueIds = uniqBy(listIdsInLocalStore, e => {
      return e;
    });
    // make list unique

    const listFullData = keyBy(filteredData, Const.NewsAggregatorTable.ID);
    const listIds = filteredData.map(item =>
      getDataFollowKeyByDot(item, Const.NewsAggregatorTable.ID),
    );
    const idsInCurrentList = uniqueIds.filter(id => listIds.includes(id));

    const optProps = isShortByFavorite
      ? {
          isGroupData: false,
          ids: idsInCurrentList,
        }
      : {
          ids: listIds,
        };

    return (
      <CommonTable
        isOnlyShowDate={true}
        dateTitleFormat="MMMM YYYY"
        dateKey="publicDate"
        listColumn={Const.PremiumAnalysisTable}
        list={listFullData}
        isLoading={isLoading}
        isShortByFavorite={isShortByFavorite}
        type="pa"
        commonData={premiumAnalysisData}
        {...optProps}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    premiumAnalysisData: state[REDUCER_NAME].premiumAnalysisData,
    i18n: state.i18n,
    userInfo: state.userInfo,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchPremiumAnalysis: status => dispatch(fetchPremiumAnalysis(status)),
    resetStoreData: storeName => dispatch(resetStoreData(storeName)),
  };
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(PremiumAnalysis);
